import React, { useState } from 'react'
import { WorkflowStep } from '../../../lib/types'
import './workflow-step-card.css'
import { Link, useNavigate } from 'react-router-dom'
import StepTypeLabels from '../../../steps/labels'
import Tag from '../../../components/tag'
import { tasks } from '../../../lib/api'
import Loading from '../../../components/loading'
import { isCycleStep } from '../../util'

type Props = {
    id: number
    idx: number
    step: WorkflowStep
    hasAccess: boolean
    isErrorRows?: boolean
    disableNextTask?: boolean
}

export default function WorkflowStepCard(props: Props) {
    const { id, idx, step, hasAccess, disableNextTask, isErrorRows } = props
    const [loadingNextTask, setLoadingNextTask] = useState(false)
    const [noTasksAvailable, setNoTasksAvailable] = useState(false)
    const [workflowComplete, setWorkflowComplete] = useState(false)
    const navigate = useNavigate()

    async function getNextTask() {
        setLoadingNextTask(true)
        try {
            const nextTask = await tasks.getNext(Number(id))
            const srcId = nextTask.srcId || 0
            navigate(`/workflows/${id}/steps/${idx}/view/${nextTask.objId}/${srcId}`)
        } catch (err) {
            const message = (err as Error).message || String(err)
            if (message === 'Workflow cycle completed') {
                setWorkflowComplete(true)
            } else {
                setNoTasksAvailable(true)
            }
        } finally {
            setLoadingNextTask(false)
        }
    }

    return (
        <div className='workflow-step-card'>
            <div className='font-medium'>{step.name}</div>
            <div className='text-sm text-gray-400'>{StepTypeLabels[step.type]}</div>
            <div className='text-sm my-4'>
                {step.roles.map((role, i) => (
                    <Tag color='yellow' key={i}>
                        {role}
                    </Tag>
                ))}
            </div>
            {hasAccess && step.type === 'input' && step.dataSource?.canInsert && step.skipTable && (
                isErrorRows ? <Link className='button red' to={`/workflows/${id}/steps/${idx}?view=my-error`}>
                    <i className="lni lni-warning" /> View Error Rows
                </Link> :
                    <Link className='button yellow' to={`/workflows/${id}/steps/${idx}/view/_`}>
                        <i className='lni lni-circle-plus' /> Insert New Row
                    </Link>
            )}
            {hasAccess && !isCycleStep(step) && !step.skipTable && (
                <Link className='button' to={`/workflows/${id}/steps/${idx}`}>
                    Access
                </Link>
            )}
            {hasAccess && isCycleStep(step) && (
                <>
                    <button
                        className='button blue'
                        onClick={getNextTask}
                        disabled={loadingNextTask || disableNextTask || noTasksAvailable || workflowComplete}
                    >
                        {loadingNextTask ? <Loading /> : 'Get Next Task'}
                    </button>
                    {noTasksAvailable && (
                        <p className='text-sm text-red-500 mt-2'>
                            There are no more correction tasks available for this cycle.
                        </p>
                    )}
                    {workflowComplete && (
                        <p className='text-sm text-green-600 mt-2'>
                            Workflow complete! All tasks have been completed for this cycle.
                        </p>
                    )}
                </>
            )}
        </div>
    )
}
